import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {DataService, ResolveCategory} from '../../services/data.service';
import {ApiService} from '../../services/api.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {Router} from '@angular/router';
import {PracticeChangeService} from '../../services/practice-change.service';
import {ReportingService} from '../../services/reporting.service';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import {SeriesOptionsType} from 'highcharts';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Subscription} from "rxjs";
import {ExtensionActivity, Hort360PropertySummary} from "../../../../functions/src/types";
import {PropertyService} from "../../services/property.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  searchOptions = [];
  intCalculate = null;
  greeting$;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: []
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Interactions'
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: 'bold',
          color: ( // theme
            Highcharts.defaultOptions.title.style &&
            Highcharts.defaultOptions.title.style.color
          ) || 'gray'
        }
      }
    },
    tooltip: {
      headerFormat: '<b>{point.x}</b><br/>',
      pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        }
      }
    },
    series: []
  };
  reportLoading = true;

  flaggedProperties: Hort360PropertySummary[] = [];
  flaggedPropertiesUser: Hort360PropertySummary[] = [];
  contactSubscription: Subscription;

  public primaryColor = '#5eff00';

  constructor(
      public apiServices: ApiService,
      public userService: UserService,
      public dataService: DataService,
      public propertyService: PropertyService,
      public router: Router,
      public practiceChangeService: PracticeChangeService,
      public reportingService: ReportingService,
      public resolveCategory: ResolveCategory,
      public fbDb: AngularFirestore,
  ) {
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
    this.primaryColor = primaryColor ?? this.primaryColor;
  }

  ngOnDestroy() {
    if (this.intCalculate) {
      clearInterval(this.intCalculate);
    }
    if (this.contactSubscription) {
      this.contactSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.calculateGreeting();
    this.intCalculate = setInterval(() => this.calculateGreeting(), 60000);

    if (!this.userService.hasActiveUser) {
      this.router.navigate(['login']);
    }

    // Watch for flagged contacts;
    this.contactSubscription = this.fbDb.collection<ExtensionActivity>(this.dataService.contactsRef.ref,
        ref => ref.where('flagged', '==', true)
                          .orderBy('date', 'desc'))
      .valueChanges().subscribe(v => {
        this.flaggedProperties = this.propertyService.getPropertySummaries(v.map(c => c.property + '').filter((p, i, a) => a.indexOf(p) === i));
        this.flaggedPropertiesUser = this.propertyService.getPropertySummaries(v.filter(c => c.user === this.userService.activeUserId + '').map(c => c.property + '').filter((p, i, a) => a.indexOf(p) === i));
      }
    );

    // Load data;
    if (this.dataService.initialLoad) {
      this.dataService.initialLoad.then(v => this.loadReport());
    } else {
      this.loadReport();
    }
  }

  loadReport() {
    (this.chartOptions.xAxis as any).categories = [];
    this.chartOptions.series = [];
    this.reportLoading = true;
    const days = 7;
    const from = moment().subtract(days, 'days').set('hour', 0).set('minute', 0).set('second', 0);
    const to = moment().set('hour', 23).set('minute', 59).set('second', 59);
    this.reportingService.get(from.format('X'), to.format('X'), this.userService.activeUserId + '').then(results => {
      const categories: {[key: string]: number[]} = {};
      results.uniqueCategories.forEach(uc => categories[uc] = []);

      const labels = [];
      for (let d = 0; d <= days; d++) { // Include today?
        const dayStart = from.clone().add('days', d);
        const dayEnd = dayStart.clone().set('hour', 23).set('minute', 59).set('second', 59);
        const dailyResults = results.reportingFor(dayStart.format('X'), dayEnd.format('X'));
        console.log(dailyResults);

        // How many?
        const interactions = dailyResults.interactionsPerCategory;
        Object.keys(categories).forEach(cat => {
          let value = null;
          if (interactions.hasOwnProperty(cat)) {
            value = interactions[cat];
          }
          categories[cat].push(value);
        });

        // Add label
        labels.push(dayStart.format('DD/MM'));
      }
      (this.chartOptions.xAxis as any).categories = labels;
      this.chartOptions.series = Object.keys(categories).map(cat => {
        const categoryType = this.resolveCategory.transform(cat);
        return {
          name: categoryType.name,
          color: categoryType.color,
          data: categories[cat]
        } as SeriesOptionsType;
      });
      this.reportLoading = false;
    }, e => {
      console.error(e);
    });
  }

  calculateGreeting() {
    const hour = new Date().getHours();
    if (hour < 12) {
      this.greeting$ = 'Good Morning';
    } else if (hour >= 12 && hour <= 17) {
      this.greeting$ = 'Good Afternoon';
    } else if (hour >= 17) {
      this.greeting$ = 'Good Evening';
    }
  }

}
